import React from "react"
import Helmet from "react-helmet"
import Link from "gatsby-link"
import Board from "../components/board.js"
import styles from "../styles/about.module.scss"

export default ({data}) =>
  <div>
  	<Helmet
      title={`About | ${data.site.siteMetadata.title}`}
    />
	<section>
  		<h2 className={styles.sectionTitle}>{data.site.siteMetadata.title} #とは</h2>
	  	<Board>
		  	<p>
		  		札幌のカジュアルなバーを会場として飲食を楽しみつつ、毎回ひとつのテーマを決め、研究発表(トークイベント)や、勉強会などを行う会です。<br />
				数学、物理学から哲学、芸術まで、普段かかわることのない分野の知識に触れ、職業や年齢に関係なく、フリーダムに学び、考えることを楽しめればと思います。
		  	</p>
	  	</Board>
	</section>
	<section>
	    <h2 className={styles.sectionTitle}>開催の動機</h2>
	    <Board>
		    <ul>
		    	<li>
		    		東京でやってる
		    		<a href="http://kiwi-lab.com/event.html" target="_blank">
		    			大人の科学バー
		    		</a>
		    		に行きたいけどなかなかタイミングが合わない。
		    	</li>
		    	<li>札幌で面白い研究をしてる人を知りたい。</li>
		    	<li>大人になって、仕事以外で真面目に議論したり講義を聴いたりする機会がない。</li>
		    	<li>学生時代、白熊の生態ビデオを見ながら飲んでたノリをまたやりたい。</li>
		    </ul>
		</Board>
	</section>
	<section>
	    <h2 className={styles.sectionTitle}>開催日時など</h2>
	    <Board>
		    <p>
		    	まだ発足直後なのでわかりませんが、ひとまず隔月以上で開催できるようにしていきたいとは思っています。
		    	会場も最初のうちは何回か変更するかもしれません。<br />
		    	不明点などあれば<Link to="/contact">Contact</Link>の連絡先へどうぞ。
		    </p>
		</Board>
	</section>
  </div>

export const query = graphql`
  query aboutQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/about.js